import React, {Component} from 'react';
import ReactDOM from 'react-dom'
import Styles from './style.css';
import HeaderSignupOne from "../../components/header-signup-one/component";
import {BeatLoader} from 'react-spinners';
import cx from "classnames";
import {langRegister} from "../../services/langRegister";
import Footer from "../../components/footer/component";
import HeaderHomeTwo from "../../components/header-home-two/component";
import countryCodes from "country-telephone-data";
import scrollToComponent from 'react-scroll-to-component';
import {marketRegister} from "../../services/marketRegister";
import ModalVideo from "../../components/modal-video/component";
import ModalLang from "../../components/modal-lang/component";
import {salesChannelRegister} from "../../services/salesChannelRegister";

class Reseller extends Component {

    constructor(props) {
        super(props);
        this.state = {
            terms: false,
            countries: [],
            country: null,
            video: false,
            search: ""
        };
        this.signupRef = React.createRef();
    };

    componentDidMount() {
        this._updateCountries();
        if(this.props.location.search === "?scrolldown=signup"){
            scrollToComponent(this.signupRef.current, { offset: 500, duration: 500});
        }else{
            window.scrollTo(0, 0);
        }
        this._setVideo = this._setVideo.bind(this);
    }

    _updateCountries() {
        let countries = JSON.parse(JSON.stringify(countryCodes.allCountries));
        for (let i = 0; i < countries.length; i++) {
            countries[i].dialCode = "+" + countries[i].dialCode;
            if (countries[i].iso2 ===  salesChannelRegister.get("market")) {
                this._selectCountry(countries[i]);
            }
        }
        this.setState({countries: countries});
    }

    _scrollTo(){
        scrollToComponent(this.signupRef.current, { offset: -150, duration: 500});
    }

    _selectCountry(option) {
        this.setState({country: option, search: option.dialCode}, () => {
            console.log(this.state.country);
        });
    }

    _setVideo(value){
        this.setState({video: value});
    }

    _renderText(item) {
        return langRegister.get("reseller", item);
    }

    render() {
        return (
              <div className={Styles.view}>
                  {
                      this.state.video &&
                      <ModalVideo setVideo={this._setVideo} props={this.props}/>
                  }
                  <HeaderHomeTwo view={"about"} props={this.props}/>
                  <div className={Styles.sectionOne}>
                      <img onClick={() => this._setVideo(true)} className={Styles.sectionOneImageMobile} src={require("../../assets/images/AB_figures_mobile_reseller.png")}/>
                      <div className={Styles.sectionOneInner}>
                          <div onClick={() => this._setVideo(true)}  style={{position: "absolute", top: 0, bottom: 0, left: 0, right: 0}}/>
                          <div className={Styles.sectionOneText}>
                              {this._renderText("item_1")}
                              <div className={Styles.sectionOneTextGreen}>{this._renderText("item_2")}</div>
                              <div className={Styles.sectionOneTextGreenSmall}>
                                  {this._renderText("item_3")}
                              </div>
                              <div onClick={() => this._scrollTo()} className={Styles.sectionOneButton}>
                                  {this._renderText("item_4")}
                              </div>
                          </div>
                          <div className={Styles.sectionOneFiller}/>
                      </div>
                      <div className={Styles.sectionOneImage}>
                          <img className={Styles.sectionOneImageItem} src={require("../../assets/images/AB_figures_desktop_reseller.png")}/>
                      </div>
                      <img className={Styles.sectionOneShadow}
                           src={require("../../assets/images/AB_shadow_horisontal2_desktop_reseller.png")}/>
                      <img className={Styles.sectionOneShadowMobile}
                           src={require("../../assets/images/AB_shadow_horisontal2_mobile_reseller.png")}/>
                  </div>
                  <div className={Styles.sectionTwo}>
                      <div className={Styles.sectionTwoInner}>
                          <div className={Styles.sectionTwoText}>
                              {this._renderText("item_5")}
                              <div className={Styles.sectionTwoTextSubtitle}>
                                  {this._renderText("item_6")}
                              </div>
                              <div className={Styles.sectionTwoTextSmall}>
                                  {this._renderText("item_7")}
                              </div>
                              <div className={Styles.sectionTwoTextBullets}>
                                  <div className={Styles.sectionTwoTextBulletsItem}>
                                      <img className={Styles.sectionTwoTextBulletsItemIcon} src={require("../../assets/images/AB_checkmark_reseller.png")}/>
                                    <div className={Styles.sectionTwoTextBulletsItemText}>
                                        {this._renderText("item_8")}
                                    </div>
                                  </div>
                                  <div className={Styles.sectionTwoTextBulletsItem}>
                                      <img className={Styles.sectionTwoTextBulletsItemIcon} src={require("../../assets/images/AB_checkmark_reseller.png")}/>
                                      <div className={Styles.sectionTwoTextBulletsItemText}>
                                          {this._renderText("item_9")}
                                      </div>
                                  </div>
                                  <div className={Styles.sectionTwoTextBulletsItem}>
                                      <img className={Styles.sectionTwoTextBulletsItemIcon} src={require("../../assets/images/AB_checkmark_reseller.png")}/>
                                      <div className={Styles.sectionTwoTextBulletsItemText}>
                                          {this._renderText("item_10")}
                                      </div>
                                  </div>
                                  <div className={Styles.sectionTwoTextBulletsItem}>
                                      <img className={Styles.sectionTwoTextBulletsItemIcon} src={require("../../assets/images/AB_checkmark_reseller.png")}/>
                                      <div className={Styles.sectionTwoTextBulletsItemText}>
                                          {this._renderText("item_11")}
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div className={Styles.sectionTwoImage}>
                              {
                                  salesChannelRegister.get("market") === "ae" &&
                                  <img className={Styles.sectionTwoImageItem}
                                       src={require("../../assets/images/AB_iPad_AE_EN.png")}/>
                              }
                              {
                                  salesChannelRegister.get("market") === "se" && langRegister.lang() === "sv" &&
                                  <img className={Styles.sectionTwoImageItem}
                                       src={require("../../assets/images/AB_iPad_SE_SV.png")}/>
                              }
                              {
                                  salesChannelRegister.get("market") === "se" && langRegister.lang() === "en" &&
                                  <img className={Styles.sectionTwoImageItem}
                                       src={require("../../assets/images/AB_iPad_SE_EN.png")}/>
                              }
                          </div>
                      </div>
                      <img className={Styles.sectionTwoShadowMobile}
                           src={require("../../assets/images/AB_shadow_horisontal2_mobile_reseller.png")}/>
                      <img className={Styles.sectionTwoShadowBottom}
                           src={require("../../assets/images/AB_shadow_horisontal2_desktop_reseller.png")}/>
                  </div>
                  <div ref={this.signupRef} className={Styles.sectionThree}>
                      <div className={Styles.sectionThreeInnerTop}>
                          <div className={Styles.sectionThreeText}>
                              {this._renderText("item_12")}&nbsp;<span className={Styles.sectionThreeTextGreen}>{this._renderText("item_13")}</span>
                          </div>
                      </div>
                      <div className={Styles.sectionThreeInnerBottom}>
                          <div className={Styles.sectionThreeSubtitle}>
                              {this._renderText("item_14")}
                          </div>
                          <div className={Styles.sectionThreeDivider}>
                              <div className={Styles.sectionThreeDividerTitle}>
                                  {this._renderText("item_15")}
                              </div>
                          </div>
                          <div className={Styles.inputDivider}>
                              <div className={Styles.inputDividerItem}>
                                  <input className={cx(Styles.input)} value={this.state.first_name} placeholder={this._renderText("item_16")}/>
                              </div>
                              <div className={Styles.inputDividerItem}>
                                  <input className={cx(Styles.input)} value={this.state.last_name} placeholder={this._renderText("item_17")}/>
                              </div>
                          </div>
                          <div className={Styles.inputDivider}>
                              <div className={Styles.inputDividerItem}>
                                  <input className={cx(Styles.input)} value={this.state.first_name} placeholder={this._renderText("item_18")}/>
                              </div>
                              <div className={Styles.inputDividerItem}>
                                  <input className={cx(Styles.input)} value={this.state.last_name} placeholder={this._renderText("item_19")}/>
                              </div>
                          </div>
                          <div className={Styles.inputDivider}>
                              <div className={Styles.inputDividerItem}>
                                  <input className={cx(Styles.input)} value={this.state.first_name} placeholder={this._renderText("item_20")}/>
                              </div>
                              <div className={Styles.inputDividerItem}>
                                  <input className={cx(Styles.input)} value={this.state.last_name} placeholder={this._renderText("item_21")}/>
                              </div>
                          </div>
                          <div className={Styles.inputDivider}>
                              <div className={Styles.inputDividerItem}>
                                  <input className={cx(Styles.input)} value={this.state.first_name} placeholder={this._renderText("item_22")}/>
                              </div>
                              <div className={Styles.inputDividerItem}>
                                  <input className={cx(Styles.input)} value={this.state.last_name} placeholder={this._renderText("item_23")}/>
                              </div>
                          </div>
                          <div className={Styles.inputDivider}>
                              <div className={Styles.inputDividerItem}>
                                  <input className={cx(Styles.input)} value={this.state.first_name} placeholder={this._renderText("item_24")}/>
                              </div>
                              <div className={Styles.inputDividerItem}>
                                  <div className={Styles.inputDividerItemInner}>
                                      <div className={Styles.inputDividerItemInnerDropdown}>
                                          <input
                                                type="tel"
                                                onFocus={() => this.setState({dropdown: true})}
                                                onBlur={() => this.setState({dropdown: false})}
                                                value={this.state.search}
                                                onChange={(event) => this.setState({search: event.target.value})}
                                                className={Styles.inputDividerItemInnerDropdownInput}
                                          />
                                          {
                                              this.state.dropdown && this.state.countries.filter((item) => {
                                                  return item.dialCode.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1
                                              }).length > 0 &&
                                              <div className={Styles.dropdownList}>
                                                  {
                                                      this.state.countries.filter((item) => {
                                                          return item.dialCode.toLowerCase().indexOf(this.state.search.toLowerCase()) !== -1
                                                      }).map((prop, key) => {
                                                          return (
                                                                <div key={key}
                                                                     onMouseDown={() => this._selectCountry(prop)}
                                                                     className={Styles.dropdownListItem}>
                                                                    {prop.dialCode}
                                                                </div>
                                                          )
                                                      })
                                                  }
                                              </div>
                                          }
                                      </div>
                                      <div className={Styles.inputDividerItemInnerInput}>
                                          <input
                                                type="tel"
                                                value={this.state.phone}
                                                onChange={(event) => this.setState({phone: event.target.value})}
                                                className={Styles.input}
                                                placeholder={this._renderText("item_25")}
                                          />
                                      </div>
                                  </div>
                              </div>
                          </div>
                          <div className={Styles.inputDividerItem}>
                              <div className={Styles.checkMarksContainerItem}>
                                  {
                                      !this.state.terms &&
                                      <img onClick={() => this.setState({terms: true})}
                                           src={require("../../assets/images/square_checkmark_two.svg")}
                                           className={Styles.checkMarksContainerItemIcon}/>
                                  }
                                  {
                                      this.state.terms &&
                                      <img onClick={() => this.setState({terms: false})}
                                           src={require("../../assets/images/square_checkmark_active.svg")}
                                           className={Styles.checkMarksContainerItemIcon}/>
                                  }
                                  <div className={Styles.checkMarksContainerItemText}>
                                      {this._renderText("item_29")} <span className={Styles.checkMarksContainerItemTextBold}>{this._renderText("item_30")}</span>
                                  </div>
                              </div>
                          </div>
                          <div className={Styles.sectionThreeButton}>
                              {this._renderText("item_26")}
                          </div>
                          <div className={Styles.sectionThreeButtonText}>
                              {this._renderText("item_27")} <span onClick={() => this.props.history.push("/" + salesChannelRegister.get("market") + "/" + langRegister.lang() + "/login")} className={Styles.sectionThreeButtonTextBold}>{this._renderText("item_28")}</span>
                          </div>
                      </div>
                  </div>
                  <Footer props={this.props}/>
              </div>
        );
    }

    /*
     <div className={Styles.sectionThree}>
                      <div className={Styles.sectionThreeText}>
                          {this._renderText("item_7")}
                          <span className={Styles.sectionThreeTextGreen}>{this._renderText("item_8")}</span>
                          {this._renderText("item_9")}
                          <br className={Styles.sectionThreeTextBreak}/>
                          <span className={Styles.sectionThreeTextGreen}>{this._renderText("item_10")}</span>
                          <br className={Styles.sectionThreeTextBreak}/>
                          {this._renderText("item_11")}
                          <div className={Styles.sectionThreeTextSmall}>
                              {this._renderText("item_12")}
                          </div>
                          <div className={Styles.sectionThreeButton}>
                              {this._renderText("item_13")}
                          </div>
                      </div>
                      <div className={Styles.sectionThreeFiller}/>
                      <div className={Styles.sectionThreeImage}>
                          <img className={Styles.sectionThreeImageItem}
                               src={require("../../assets/images/AB_illustration_cards.png")}/>
                      </div>
                  </div>
     */
}

export default Reseller;


// WEBPACK FOOTER //
// ./src/pages/reseller/component.js